import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { styled } from 'dripsy';

import { useAsyncInit, useNavOptionsSet } from '@hooks';
import { IS_WEB, parseApiError } from '@utils';
import { ToastService } from '@services';
import { BaseText } from '@components';
import { useViewerModel } from '@models/Viewer/ViewerModel';
import { SuggestedFriendsList } from './components/SuggestedFriendsList';

const Container = styled(View)({
  flex: 1,
  bg: '$background0',
});

const ContentContainer = styled(View)({
  flex: 1,
  mx: [null, '5%'],
  maxWidth: [null, 600],
});

const Title = styled(BaseText)({
  color: '$heading800',
  variant: 'text.xbig',
  fontWeight: 'semi',
});

export const FindFriendScreen = observer(() => {
  const { t } = useTranslation();
  const viewer = useViewerModel();

  useNavOptionsSet({
    title: t('findFriend.title'),
  });

  useAsyncInit(async () => {
    try {
      await viewer.usersSuggestion.list.fetch.run();
    } catch (e) {
      ToastService.showError(parseApiError(e).message);
    }
  });

  return (
    <Container>
      <ContentContainer>
        {IS_WEB && <Title>{t('findFriend.title')}</Title>}

        <SuggestedFriendsList list={viewer.usersSuggestion.list} />
      </ContentContainer>
    </Container>
  );
});
